import uuid from 'short-uuid';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const carregarIdentificacaoNavegadorAsync = async () => {
  let identificacaoNavegador = await AsyncStorage.getItem(
    'identificacaoNavegador'
  );

  if (!identificacaoNavegador) {
    identificacaoNavegador = uuid.generate();

    await AsyncStorage.setItem(
      'identificacaoNavegador',
      identificacaoNavegador
    );

    return identificacaoNavegador;
  }

  return identificacaoNavegador || '';
};

export function ehIE() {
  return /MSIE|Trident\//.test(navigator.userAgent);
}
